import type { ReactNode } from 'react';
import { Spinner } from './spinner.js';

/**
 * A button's own words, and - while the call it started runs - the spinner
 * beside them (RE-35, settled with Matthew 27 October): the answer to "did my
 * tap count?" appears exactly where the thumb is, and the button keeps its
 * word and size, so it never changes meaning under the finger (RE-22). The
 * action in progress ("Saving…") is said to screen readers only.
 *
 * The owner disables the button and marks it aria-busy, so it reads as
 * working, not unavailable (styles/progress.css).
 */
export function BusyLabel({ busy, working, children }: { busy: boolean; working: string; children: ReactNode }) {
  if (!busy) return <>{children}</>;
  return (
    <>
      <Spinner />
      {children}
      <span className="visually-hidden" role="status">
        {working}
      </span>
    </>
  );
}
